import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

//components
import { PageSectionInner } from '@/components/PageSection';
import { HeroFx } from '@/components/HeroFx';

// the photo overlaps the section that follows by this much
const OVERLAP = 'clamp(48px, 7vw, 100px)';

export const HeroWrapper = styled.header`
  position: relative;
  isolation: isolate;
  z-index: 2;
  padding: clamp(56px, 6vw, 88px) 0 0;
  background: radial-gradient(
      ellipse 912px 1036px at 50% 0,
      #004a4a 0%,
      #003434 23%,
      #001b1b 46%,
      #000 85%,
      #000 100%
    ),
    #000;
  font: 400 16px / 1.6 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-inverted')});

  & + section {
    padding-top: calc(var(--pad, 96px) + ${OVERLAP});
  }
`;

export const HeroEffect = styled(HeroFx)`
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0.38;
  mask-image: linear-gradient(to bottom, #000 62%, transparent 100%);
`;

export const HeroInner = styled(PageSectionInner)`
  display: block;

  ${screen.lg} {
    display: grid;
    grid-template-columns: minmax(0, 8fr) minmax(0, 5fr);
    gap: 0 clamp(32px, 5vw, 64px);
    align-items: start;
  }
`;

export const Title = styled.h1`
  margin: 0 0 20px;
  font: 700 clamp(36px, 4.1vw, 52px) / 1.2 ${getToken('font-family-title')};
  letter-spacing: -0.02em;
  color: rgb(${getToken('color-brand')});
  text-wrap: balance;

  span {
    display: block;
  }

  ${screen.lg} {
    grid-column: 1;
    grid-row: 1;
    margin: 0 0 clamp(32px, 4vw, 56px);
  }
`;

export const Copy = styled.p`
  margin: 0 0 32px;
  font: 500 clamp(17px, 1.45vw, 19px) / 1.65 ${getToken('font-family-default')};
  color: rgba(252, 252, 255, 0.9);

  ${screen.lg} {
    grid-column: 2;
    grid-row: 1;
    margin: 0 0 clamp(32px, 4vw, 56px);
  }
`;

export const TeamPhoto = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  object-position: 50% 60%;
  border-radius: 14px;
  margin-bottom: calc(-1 * ${OVERLAP});

  ${screen.md} {
    aspect-ratio: 2 / 1;
    object-position: center;
  }

  ${screen.lg} {
    grid-column: 1 / -1;
    grid-row: 2;
    aspect-ratio: 1920 / 745;
    border-radius: 20px;
  }
`;
